import { AppGlobalState } from 'modules/types'

const props = (state: AppGlobalState) => state.snackbar

export const SnackbarSelectors = {
  props,
} as const
